import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { NotifierService } from "angular-notifier";

@Injectable({
  providedIn: 'root'
})
export class IntegrationService {

  private readonly notifier: NotifierService;
  userId$: Observable<any>;
  userName$: Observable<any>;
  email$: Observable<any>;
  phone$: Observable<any>;
  alertTypes: Observable<any>;
  showNav$:Observable<any>;
  subscriptionPlan$: Observable<any>;
  listViewPromo$: Observable<any>;
  checkoutUrl$: Observable<any>;
  
  private userIdSubject = new Subject<any>();
  private userNameSubject = new Subject<any>();
  private emailSubject = new Subject<any>();
  private phoneSubject = new Subject<any>();
  private alertTypesSubject = new Subject<any>();
  public listViewPromoSubject =  new Subject<any>();
  public showNavSubject = new Subject<any>();
  public subscriptionPlanSubject = new Subject<any>();
  public checkoutUrlSubject = new Subject<any>();


  public loggedIn = false;

  constructor(private router:Router,private http:HttpClient,notifierService: NotifierService) {
    this.userId$ = this.userIdSubject.asObservable();
    this.userName$ = this.userNameSubject.asObservable();
    this.email$ = this.emailSubject.asObservable();
    this.phone$ = this.phoneSubject.asObservable();
    this.alertTypes = this.alertTypesSubject.asObservable();
    this.showNav$ = this.showNavSubject.asObservable();
    this.subscriptionPlan$ = this.subscriptionPlanSubject.asObservable();
    this.listViewPromo$ = this.listViewPromoSubject.asObservable();
    this.checkoutUrl$ = this.checkoutUrlSubject.asObservable();
    this.notifier = notifierService;
  }

  setToken(){
    let data = {
      email: 'test@test.com',
      password: 'test123'
    }
    this.http.post('https://subscrybe-backend.herokuapp.com/login',data).subscribe(
      data=>{
        let token = data['token'];
        localStorage.setItem('token', token);
      }
    )
  }

  getUser(){
    let token = localStorage.getItem('token')
    let refreshToken = localStorage.getItem('refreshToken')
    if(!token && !refreshToken){
      this.router.navigate(['/signup'])
    }
    let currentUserEndpoint = 'https://subscrybe-backend.herokuapp.com/current-user';
    let refreshEndpoint = 'https://subscrybe-backend.herokuapp.com/refresh'
    var header = {
      headers: new HttpHeaders()
        .set('Authorization',  `Bearer ${token}==`)
    }
    this.http.get(currentUserEndpoint,header).subscribe(
      data =>{
        let userId = data['logged_in_as']['_id']
        let username = data['logged_in_as']['username'] ? data['logged_in_as']['username'] : 'My'
        let phone = data['logged_in_as']['phone'] ? data['logged_in_as']['phone'] : ''
        phone = phone.length > 5 ? phone : ''
        let email = data['logged_in_as']['email'] ? data['logged_in_as']['email'] : ''
        let alertTypes = data['logged_in_as']['alert_type'] ? data['logged_in_as']['alert_type'] : []
        let subscriptionPlan = data['logged_in_as']['subscription'] ? data['logged_in_as']['subscription'] : []
        this.userNameSubject.next(username)
        this.phoneSubject.next(phone);
        this.emailSubject.next(email);
        this.alertTypesSubject.next(alertTypes)
        this.subscriptionPlanSubject.next(subscriptionPlan)
        if(userId){
          this.loggedIn = true;
          this.userIdSubject.next(userId)
        }
      }, error => {
        // alert(JSON.stringify(error))
        console.log('we gatta fam')
        var refreshHeader = {
          headers: new HttpHeaders()
            .set('Authorization',  `Bearer ${refreshToken}==`)
        }
        this.http.post(refreshEndpoint,{},refreshHeader).subscribe(
          data=>{
            let newToken = data['access_token']
            localStorage.setItem('token',newToken)
            let userId = data['logged_in_as']['_id']
            let username = data['logged_in_as']['username'] ? data['logged_in_as']['username'] : 'My'
            let phone = data['logged_in_as']['phone'] ? data['logged_in_as']['phone'] : ''
            phone = phone.length > 5 ? phone : ''
            let email = data['logged_in_as']['email'] ? data['logged_in_as']['email'] : ''
            let subscriptionPlan = data['logged_in_as']['subscription'] ? data['logged_in_as']['subscription'] : []
            let alertTypes = data['logged_in_as']['alert_type'] ? data['logged_in_as']['alert_type'] : []
            this.subscriptionPlanSubject.next(subscriptionPlan)
            this.phoneSubject.next(phone);
            this.emailSubject.next(email);
            this.alertTypesSubject.next(alertTypes)
            this.userNameSubject.next(username)
            if(userId){
              this.loggedIn = true;
              this.userIdSubject.next(userId)
            }
          }, error =>{
            if(token){
              this.router.navigate(['/signin'])
            } else{
              this.router.navigate(['/signup'])
            }
            
          }
        )
      }
    )
  }

  registerUser(username='',email,password,phone,alertType=[]){
    console.log(alertType)
    let data = {
      username,
      email:email,
      password:password,
      phone:phone,
      alertType
    }
    let registrationEndpoint = 'https://subscrybe-backend.herokuapp.com/register';
    let currentUserEndpoint = 'https://subscrybe-backend.herokuapp.com/current-user';
    this.http.post(registrationEndpoint,data).subscribe(
      data=>{
        let token = data['token']
        let refreshToken = data['refreshToken']
        localStorage.setItem('token',token)
        localStorage.setItem('refreshToken',refreshToken)
        var header = {
          headers: new HttpHeaders()
            .set('Authorization',  `Bearer ${token}==`)
        }
        this.http.get(currentUserEndpoint,header).subscribe(
          data =>{
            let userId = data['logged_in_as']['_id']
            let username = data['logged_in_as']['username'] ? data['logged_in_as']['username'] : 'My'
            this.userNameSubject.next(username)
            if(userId){
              this.getUser()
              this.router.navigate(['/dashboard'])
            }
          },error=>{
            this.notifier.notify("error", "Error signing up");
          }
        )
      }
    )

  }

  authenticateUser(email,password){
    let data = {
      email: email,
      password: password
    }
    this.http.post('https://subscrybe-backend.herokuapp.com/login',data).subscribe(
      data=>{
        let token = data['token'];
        let refreshToken = data['refreshToken']
        localStorage.setItem('token', token);
        localStorage.setItem('refreshToken', refreshToken);
        this.getUser()
        this.router.navigate(['dashboard'])
      },error=>{
        this.notifier.notify("error", "Login failed");
      }
    )
  }
}
